import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import NavbarSidebarButton from './NavbarSidebarButton.view';
import NavbarProfile from './NavbarProfile.view';

class Navbar extends PureComponent {
  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility } = this.props;

    return (
      <div className='topbar'>
        <div className='topbar__wrapper'>
          <div className='topbar__left'>
            <NavbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
            <Link className='topbar__logo' to='/dashboard_default' />
          </div>
          <div className='topbar__right'>
            <NavbarProfile />
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;
